<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_v"></a><a id="title"></a>THE<br/><br/><span class="big1">I</span>LLUMINATOR</h1>
<p class="center"><img alt="Image" src="images/title-img.jpg"/></p>
<p class="author">B<span class="small">RENDA</span> R<span class="small">ICKMAN</span><br/><br/>V<span class="small">ANTREASE</span></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
<p class="pub">ST. MARTIN’S GRIFFIN</p>
<p class="pub">NEW YORK</p>
<p class="pub"><img alt="image" src="images/pub1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2265d6b0